<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" />
        <action-button type="save" @click="save" v-if="!passport.id" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs4>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      name="passport.name"
                      v-model="passport.name"
                      :class="passport.id ? '' : 'required-field'"
                      v-validate="'required|max:50'"
                      :label="$t('passports.name')"
                      :error-messages="errors.collect('passport.name')"
                      :readonly="Boolean(passport.id)"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 v-if="passport.id">
                    <v-text-field
                      v-model="passport.id"
                      :label="$t('passports.client_id')"
                      :readonly="Boolean(passport.id)"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 v-if="passport.id">
                    <v-text-field
                      v-model="passport.secret"
                      :label="$t('passports.client_secret')"
                      :readonly="Boolean(passport.id)"
                      :append-icon="hidePassword ? 'visibility_off' : 'visibility'"
                      @click:append="showHidePassword"
                      :type="hidePassword ? 'password' : 'text'"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs8 class="pl-4">
                <p><b>1.</b> In "login" api request. Add the following values in header request.</p>
                <v-simple-table dense class="mb-4">
                  <template v-slot:default>
                    <tbody>
                      <tr v-for="(value, key) in loginAxiosHeaders" :key="key">
                        <td>{{ key }}</td>
                        <td>{{ value }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <p><b>2.</b> For the rest of the api. Add the following values in header request.</p>
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr v-for="(value, key) in otherAxiosHeaders" :key="key">
                        <td>{{ key }}</td>
                        <td>{{ value }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "PassportForm",

  props: ["id"],

  data() {
    return {
      page_title: null,
      passport: {},
      dictionary: {
        attributes: {
          "passport.name": this.$t("passports.name")
        }
      },
      hidePassword: true,
      loginAxiosHeaders: [],
      otherAxiosHeaders: []
    }
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    this.loginAxiosHeaders = {
      "Client-Id": this.passport.id,
      "Client-Secret": this.passport.secret,
      "X-TenantId": this.$cookies.get(`${this.COOKIE_PREFIX}tenant_id`),
      "X-Tenant-Subdomain": this.SUBDOMAIN,
      "X-Locale": this.$getSetting("locale")
    }

    this.otherAxiosHeaders = {
      "X-TenantId": this.$cookies.get(`${this.COOKIE_PREFIX}tenant_id`),
      "X-Tenant-Subdomain": this.SUBDOMAIN,
      "X-Locale": this.$getSetting("locale"),
      Authorization: "Bearer <Token from login api>"
    }

    // Get Address
    if (!this.id) {
      this.page_title = this.$t("passports.create_new_key")
    } else {
      axios
        .get(this.API_URL + "passport/client/" + this.id)
        .then((res) => {
          this.passport = res.data.data

          this.loginAxiosHeaders["Client-Id"] = this.passport.id
          this.loginAxiosHeaders["Client-Secret"] = "●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●"

          this.page_title = this.$t("passports.view_passport", {
            name: this.passport.name
          })
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    save() {
      let vm = this

      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            axios
              .post(this.API_URL + "passport/client", {
                name: this.passport.name
              })
              .then((res) => {
                if (res.data.data.id) {
                  vm.passport = res.data.data
                  vm.page_title = vm.$t("passports.view_passport", {
                    name: vm.passport.name
                  })

                  vm.loginAxiosHeaders["Client-Id"] = vm.passport.id
                  vm.loginAxiosHeaders["Client-Secret"] = "●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●"

                  vm.$awn.success(vm.$t("global.create_success"))
                }
              })
              .catch((err) => console.log(err))
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    showHidePassword() {
      this.hidePassword = !this.hidePassword

      if (this.hidePassword) {
        this.loginAxiosHeaders["Client-Secret"] = "●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●"
      } else {
        this.loginAxiosHeaders["Client-Secret"] = this.passport.secret
      }
    }
  }
}
</script>

<style scoped></style>
